export const ADD_MISSION = 'ADD_MISSION';
export const REMOVE_MISSION = 'REMOVE_MISSION';
export const UPDATE_MISSION = 'UPDATE_MISSION';
export const FETCH_MISSIONS_REQUEST = 'FETCH_MISSIONS_REQUEST';
export const FETCH_MISSIONS_SUCCESS = 'FETCH_MISSIONS_SUCCESS';
export const FETCH_MISSIONS_FAILURE = 'FETCH_MISSIONS_FAILURE';
